export { default } from "./SocialEmbedSkeleton";
